import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class ModalService {  
  modalOpen = new BehaviorSubject(false);
  modalData = new BehaviorSubject(null);
  confirmEvent = new BehaviorSubject(false);
  closeEvent = new BehaviorSubject(false);

  open(data) {
    this.modalOpen.next(data);
  }
}